import UsersTable from "../../UserManagement/UsersTable";
import {IconProfile} from "../../../../icons";

import {DialogContent, IconButton} from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import {Dialog} from "@mui/material";
import {useState} from "react";


const UserPerRoleDialog = ({user, roles, clients, lots, permission, refetchUsers}) => {

    const [showList, setShowList] = useState(false);
    return (
        <>
            <IconButton size="small" onClick={() => setShowList(true)}><ListIcon/></IconButton>
            <Dialog maxWidth='xl' fullWidth open={showList} onClose={() => setShowList(false)}>
                <DialogContent>
                    <UsersTable
                        permission={permission}
                        users={user}
                        clients={clients}
                        lots={lots}
                        roles={roles}
                        searchVal={""}
                        refetchUsers={refetchUsers}
                        title={<><IconProfile/> Users Filtered by Role</>}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default UserPerRoleDialog;